import styled from "styled-components";

export const Container = styled.div``;

export const LoadingWrapper = styled.div`
  min-height: 80vh;
`;
